<template lang="html">
  <section id="register">
    <section class="hero is-primary is-small">
      <div class="hero-body">
        <div class="container">
          <h1 class="title">Register</h1>
          <h2 class="subtitle">Welcome to Costuto !</h2>
        </div>
      </div>
    </section>
    <section class="section">
      <div class="container">
        <b-steps :hasNavigation="false" v-model="activeStep">
          <!-- Basic info step -->
          <b-step-item step="1" label="Welcome" icon="account-key">
            <ValidationObserver ref="observer" v-slot="{ handleSubmit }">
              <h1 class="title has-text-centered">Welcome to Costuto !</h1>
              <div class="columns">
                <div class="column is-half">
                  <figure class="image">
                    <img
                      src="https://costuto-public.s3.eu-central-1.amazonaws.com/images/tanukos.png"
                    />
                  </figure>
                  <p class="has-text-centered">
                    I'm <b>Tanukos</b> ! Nice to meet you ~♡ You're about to join a
                    community of passionate cosplayers, crafters, artists who want to
                    share freely their knowledge and skills about Cosplay !
                  </p>
                </div>
                <div class="column is-one-third">
                  <b-field grouped>
                    <ValidationProvider
                      slim
                      rules="required|between:3,20"
                      name="Username"
                      v-slot="{ errors, valid }"
                    >
                      <b-field
                        label="Username"
                        :type="{ 'is-danger': errors[0], 'is-success': valid }"
                        :message="[
                          errors[0],
                          'The username will be used in your profile URL e.g. www.costuto.com/users/MikuHatsune39 and is definitive',
                        ]"
                        expanded
                      >
                        <b-input
                          v-model="user.username"
                          type="text"
                          name="username"
                          autocomplete="username"
                          placeholder="MikuHatsune39"
                          required
                        ></b-input>
                      </b-field>
                    </ValidationProvider>

                    <ValidationProvider
                      slim
                      rules="required|between:3,20"
                      name="Cosplayername"
                      v-slot="{ errors, valid }"
                    >
                      <b-field
                        label="Cosplayer name"
                        :type="{ 'is-danger': errors[0], 'is-success': valid }"
                        :message="[
                          errors[0],
                          'The cosplayer name is the displayed name in your profile and is easily modifiable',
                        ]"
                        expanded
                      >
                        <b-input
                          v-model="user.cosplayer_name"
                          type="text"
                          name="username"
                          placeholder="Miku Cosplay"
                          required
                        ></b-input>
                      </b-field>
                    </ValidationProvider>
                  </b-field>

                  <ValidationProvider
                    slim
                    rules="required|email"
                    name="Email"
                    v-slot="{ errors, valid }"
                  >
                    <b-field
                      label="Email"
                      :type="{ 'is-danger': errors[0], 'is-success': valid }"
                      :message="[
                        errors[0],
                        'A verification email will be sent to this address',
                      ]"
                      expanded
                    >
                      <b-input
                        v-model="user.email"
                        type="email"
                        name="email"
                        autocomplete="email"
                        placeholder="miku39@gmail.com"
                        required
                      ></b-input>
                    </b-field>
                  </ValidationProvider>

                  <ValidationProvider
                    slim
                    rules="required|between:6,30"
                    name="Password"
                    v-slot="{ errors, valid }"
                  >
                    <b-field
                      label="Password"
                      :type="{ 'is-danger': errors[0], 'is-success': valid }"
                      :message="[
                        errors[0],
                        'The password should be minimum six characters length, contain one capital letter and one number (+ an elfic character from an old spell book)',
                      ]"
                    >
                      <b-input
                        v-model="user.password"
                        type="password"
                        autocomplete="new-password"
                        name="password"
                        spellcheck="false"
                        password-reveal
                        required
                      >
                      </b-input>
                    </b-field>
                  </ValidationProvider>

                  <ValidationProvider
                    slim
                    rules="required|confirmed:Password"
                    name="Password confirmation"
                    v-slot="{ errors, valid }"
                  >
                    <b-field
                      label="Password confirmation"
                      :type="{ 'is-danger': errors[0], 'is-success': valid }"
                      :message="errors"
                    >
                      <b-input
                        v-model="user.password_confirmation"
                        type="password"
                        autocomplete="new-password"
                        name="password-confirmation"
                        spellcheck="false"
                        password-reveal
                        required
                      >
                      </b-input>
                    </b-field>
                  </ValidationProvider>
                </div>
              </div>
              <div class="columns is-centered">
                <div class="column narrow has-text-centered">
                  <b-button type="is-primary" @click.prevent="handleSubmit(nextStep)">
                    Next
                  </b-button>
                </div>
              </div>
            </ValidationObserver>
          </b-step-item>

          <!-- Avatar and misc info -->
          <b-step-item step="2" label="Profile" icon="account">
            <ValidationObserver ref="observer-a" v-slot="{ handleSubmit }">
              <h1 class="title has-text-centered">Customize your profile</h1>
              <div class="columns is-centered is-vcentered">
                <div class="column is-one-quarter has-text-centered">
                  <h2 class="title is-size-5">Avatar</h2>
                  <figure v-if="user.avatar == null" class="image is-1by1">
                    <img
                      style="border-radius: 10%"
                      src="https://costuto-public.s3.eu-central-1.amazonaws.com/images/placeholder_plus_1x1.png"
                      alt="Placeholder image"
                    />
                  </figure>

                  <figure v-else class="image is-1by1">
                    <img style="border-radius: 10%" :src="user.avatar" alt="Avatar" />
                  </figure>

                  <div class="p-2">
                    <b-button type="is-primary" @click="isAvatarUploadModalActive = true">
                      Upload Avatar
                    </b-button>
                  </div>
                </div>
                <div class="column is-two-fifths">
                  <b-field grouped>
                    <ValidationProvider
                      slim
                      rules="required"
                      name="Gender"
                      v-slot="{ errors, valid }"
                    >
                      <b-field
                        label="Gender"
                        :type="{ 'is-danger': errors[0], 'is-success': valid }"
                        :message="errors"
                        expanded
                      >
                        <b-select
                          v-model="user.gender"
                          placeholder="Choose"
                          icon="account"
                        >
                          <option value="female">Female</option>
                          <option value="male">Male</option>
                          <option value="nonbinary">Non-Binary</option>
                          <option value="other">Other</option>
                        </b-select>
                      </b-field>
                    </ValidationProvider>

                    <country-select
                      :selected-country="user.country"
                      :display-success="true"
                      @countrySelected="user.country = $event"
                    ></country-select>
                  </b-field>

                  <ValidationProvider
                    slim
                    rules="required|before"
                    name="Birthday"
                    v-slot="{ errors, valid }"
                  >
                    <b-field
                      label="Birthday"
                      :type="{ 'is-danger': errors[0], 'is-success': valid }"
                      :message="[
                        errors[0],
                        'You should be at least 13 years old to join the community',
                      ]"
                      expanded
                    >
                      <b-datepicker
                        v-model="user.birthday"
                        name="birthday"
                        placeholder="Click to select..."
                        icon="cake-variant"
                      >
                      </b-datepicker>
                    </b-field>
                  </ValidationProvider>
                </div>
              </div>
              <div class="columns is-centered">
                <div class="column is-narrow has-text-centered">
                  <b-button type="is-primary" @click="previousStep"> Previous </b-button>
                </div>
                <div class="column is-narrow has-text-centered">
                  <b-button type="is-primary" @click="handleSubmit(nextStep)">
                    Next
                  </b-button>
                </div>
              </div>
            </ValidationObserver>
          </b-step-item>

          <!-- Info review and confirmation -->
          <b-step-item step="3" label="Finish" icon="account-plus">
            <div v-if="onLastStep">
              <ValidationObserver ref="observer-as" v-slot="{ handleSubmit }">
                <h1 class="title has-text-centered">Review Profile</h1>
                <p class="has-text-centered"></p>
                <div class="columns is-centered">
                  <div class="column is-half has-text-centered">
                    <p>Here is a small overview of your profile before creation</p>
                  </div>
                </div>
                <div class="columns is-centered is-vcentered">
                  <div class="column is-2">
                    <figure v-if="user.avatar == null" class="image is-1by1">
                      <img
                        src="https://costuto-public.s3.eu-central-1.amazonaws.com/images/placeholder_3x2.png"
                        alt="Placeholder image"
                      />
                    </figure>

                    <figure v-else class="image is-1by1">
                      <img :src="user.avatar" alt="" />
                    </figure>
                  </div>
                  <div class="column is-one-quarter">
                    <b-field label="Cosplayer Name" label-position="on-border">
                      <b-input :value="user.cosplayer_name" disabled></b-input>
                    </b-field>
                    <b-field
                      label="Profile URL"
                      label-position="on-border"
                      message="This URL is definitive so choose wisely !"
                    >
                      <b-input
                        :value="`www.costuto.com/users/${user.username}`"
                        disabled
                      ></b-input>
                    </b-field>
                    <b-field grouped>
                      <b-field label="Birthday" label-position="on-border" expanded>
                        <b-input
                          :value="user.birthday.toLocaleDateString($i18n.locale)"
                          disabled
                        ></b-input>
                      </b-field>

                      <span>
                        <gender-icon class="is-inline" :gender="user.gender" />
                      </span>

                      <country-flag :country="user.country" :rounded="true" />
                    </b-field>

                    <div class="field">
                      <b-checkbox v-model="conditions" type="is-success" size="is-small">
                        I accept the <a href="#">terms and conditions</a>.
                      </b-checkbox>
                    </div>
                  </div>
                </div>

                <div class="columns is-centered">
                  <div class="column is-narrow has-text-centered">
                    <b-button type="is-primary" @click="previousStep">
                      Previous
                    </b-button>
                  </div>
                  <div class="column is-narrow has-text-centered">
                    <b-button
                      type="is-primary"
                      :disabled="!conditions"
                      @click="handleSubmit(register)"
                    >
                      Confirm & Join the community
                    </b-button>
                  </div>
                </div>
              </ValidationObserver>
            </div>
          </b-step-item>
        </b-steps>
      </div>
    </section>

    <b-modal
      :active.sync="isAvatarUploadModalActive"
      has-modal-card
      trap-focus
      aria-role="dialog"
      aria-modal
    >
      <image-uploader
        :title="'avatar'"
        :emit-signal="'avatarChanged'"
        @avatarChanged="updateAvatar"
      />
    </b-modal>

    <b-loading :is-full-page="true" :active.sync="isLoading"></b-loading>
  </section>
</template>

<script>
import _ from 'lodash'
import axios from 'axios'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import CountryFlag from 'vue-country-flag'
import ImageUploader from '@/components/modals/ImageUploader'
import GenderIcon from '@/components/GenderIcon'
import CountrySelect from '@/components/CountrySelect'
export default {
  data () {
    return {
      activeStep: 0,
      steps: 3,
      conditions: false,
      countries: [],
      isAvatarUploadModalActive: false,
      isLoading: false,
      user: {
        email: '',
        username: '',
        birthday: [],
        gender: null,
        country: null,
        password: '',
        password_confirmation: '',
        avatar: null
      }
    }
  },
  components: {
    ValidationObserver,
    ValidationProvider,
    CountryFlag,
    ImageUploader,
    GenderIcon,
    CountrySelect
  },
  computed: {
    onLastStep () {
      return this.activeStep === this.steps - 1
    }
  },
  methods: {
    nextStep () {
      let newStep = this.activeStep + 1
      this.activeStep = newStep < this.steps - 1 ? newStep : this.steps - 1
    },
    previousStep () {
      let newStep = this.activeStep - 1
      this.activeStep = newStep > 0 ? newStep : 0
    },
    getCountriesList () {
      axios
        .get('https://restcountries.eu/rest/v1/all', {
          transformRequest: [
            (data, headers) => {
              delete headers.common.Authorization
              return data
            }
          ]
        })
        .then((res) => {
          this.countries = res.data
        })
    },
    register () {
      if (this.conditions) {
        this.isLoading = true
        this.$store
          .dispatch('users/create', this.user)
          .then(() => {
            this.isLoading = false
            this.$buefy.dialog.alert({
              title: 'Account created',
              message:
                'Congratulations, your account had been created ! You will receive an email confirmation shortly, please validate your account in order to log in.',
              onConfirm: () => this.$router.push('/')
            })
          })
          .catch((_) => {
            this.isLoading = false
            this.$buefy.notification.open({
              message: 'An error occured during registration!',
              position: 'is-top',
              type: 'is-danger',
              hasIcon: true
            })
          })
      } else {
        this.$buefy.dialog.confirm({
          title: 'Accept terms and conditions',
          message: `You should first accept the terms and conditions of Costuto.`,
          cancelText: 'Disagree',
          confirmText: 'Agree',
          type: 'is-success',
          onConfirm: () => {
            this.conditions = true
          }
        })
      }
    },
    updateAvatar (value) {
      if (value) {
        this.user.avatar = value
      }
    }
  },
  created () {
    let self = this
    this.checkUsernameAvailability = _.debounce(() => {
      self.$store
        .dispatch('users/show', this.user.username)
        .then(() => {
          self.$refs.observer.setErrors({ Username: ['Username is already taken'] })
        })
        .catch(() => {})
    }, 2000)
    this.getCountriesList()
  },
  watch: {
    'user.username': function () {
      this.checkUsernameAvailability()
    }
  }
}
</script>

<style lang="scss" scoped></style>
